import axios from '@/plugins/axios';

export async function load(workspaceId){
    return await axios.get(`work-spaces/${workspaceId}`);
}

export async function listWorkspacesForUser(){
    return await axios.get(`work-spaces`);
}

export async function notifyConfigIndex(work_space, params){
    return await axios.get(`work-spaces/${work_space}/work-space-notify-config`, {params});
}

export async function notifyConfigStore(work_space, data){
    return await axios.post(`work-spaces/${work_space}/work-space-notify-config`, data);
}

export async function notifyConfigUpdate(work_space, confidId, data){
    return await axios.put(`work-spaces/${work_space}/work-space-notify-config/${confidId}`, data);
}

export async function notifyConfigDelete(work_space, confidId){
    return await axios.delete(`work-spaces/${work_space}/work-space-notify-config/${confidId}`);
}

export async function create(data){
    return await axios.post(`work-spaces`, data);
}
export async function update(wsId, data){
    return await axios.post(`work-spaces/${wsId}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export async function users(work_space, params){
    return await axios.get(`work-spaces/${work_space}/users`, {params});
}
export async function userRemove(work_space, user_id){
    return await axios.delete(`work-spaces/${work_space}/users/${user_id}`);
}
export async function invites(work_space, params){
    return await axios.get(`/work-space/invite/${work_space}`, {params});
}

export async function inviteUser(work_space, email){
    return await axios.post(`/work-space/invite/${work_space}`, {email});
}
export async function inviteShow(token){
    return await axios.get(`/invite/work-space/${token}`);
}

export async function inviteAccept(token){
    return await axios.post(`/work-space/invite/accept/${token}`);
}

export async function inviteReject(token){
    return await axios.post(`/work-space/invite/reject/${token}`);
}
export async function inviteClose(work_space, work_space_user_invite_id){
    return await axios.post(`/work-space/invite/${work_space}/close/${work_space_user_invite_id}`);
}